/** Route chunk prefetch loaders — same import targets as router lazy declarations. */

import { ROUTES } from "./route-paths";

export type RouteChunkLoader = () => Promise<unknown>;

export interface RoutePrefetchEntry {
  prefix: string;
  loaders: readonly RouteChunkLoader[];
}

const workspaceLayout = () => import("@/components/workspace/Layout");

export const ROUTE_PREFETCH_LOADERS: readonly RoutePrefetchEntry[] = [
  {
    prefix: "/",
    loaders: [() => import("@/pages/Dashboard/DashboardPage")],
  },
  {
    prefix: ROUTES.INTAKE_DASHBOARD,
    loaders: [workspaceLayout, () => import("@/pages/Intake/IntakeRails").then((m) => m), () => import("@/components/intake/pages/DashboardPage")],
  },
  {
    prefix: ROUTES.SEARCH,
    loaders: [() => import("@/pages/Platform/SearchPage")],
  },
  {
    prefix: ROUTES.FINANCE,
    loaders: [workspaceLayout, () => import("@/pages/Finance/FinanceRails").then((m) => m), () => import("@/pages/Finance/InvoicesPage")],
  },
  {
    prefix: ROUTES.WORK_PROJECTS,
    loaders: [workspaceLayout, () => import("@/pages/Work/WorkRails").then((m) => m), () => import("@/pages/Work/ProjectsPage")],
  },
  {
    prefix: ROUTES.STRATEGY,
    loaders: [workspaceLayout, () => import("@/pages/Strategy/StrategyRails").then((m) => m), () => import("@/pages/Strategy/StrategyPage")],
  },
  {
    prefix: ROUTES.PLATFORM_MONITORING,
    loaders: [workspaceLayout, () => import("@/pages/Observability/ObservabilityRails").then((m) => m), () => import("@/pages/Monitoring/MonitoringPage")],
  },
  {
    prefix: ROUTES.INTAKE_DRAFTS,
    loaders: [workspaceLayout, () => import("@/pages/Intake/IntakeRails").then((m) => m), () => import("@/components/intake/pages/DraftsPage")],
  },
  {
    prefix: ROUTES.INTAKE_RECORDS,
    loaders: [workspaceLayout, () => import("@/pages/Intake/IntakeRails").then((m) => m), () => import("@/components/intake/pages/RecordsPage")],
  },
  {
    prefix: ROUTES.INTAKE_LEDGER,
    loaders: [workspaceLayout, () => import("@/pages/Intake/IntakeRails").then((m) => m), () => import("@/components/intake/pages/LedgerPage")],
  },
  {
    prefix: ROUTES.INTAKE_DIGEST,
    loaders: [workspaceLayout, () => import("@/pages/Intake/IntakeRails").then((m) => m), () => import("@/components/intake/pages/OperationsDigestPage")],
  },
  {
    prefix: ROUTES.AI_PLATFORM,
    loaders: [() => import("@/pages/AI/AIPage"), () => import("@/pages/AI/AiRails").then((m) => m), () => import("@/pages/AI/AIChatPage")],
  },
  {
    prefix: ROUTES.KNOWLEDGE_PLATFORM,
    loaders: [workspaceLayout, () => import("@/pages/RAG/KnowledgeRails").then((m) => m), () => import("@/pages/RAG/CorpusPage")],
  },
  {
    prefix: "/rag",
    loaders: [workspaceLayout, () => import("@/pages/RAG/KnowledgeRails").then((m) => m), () => import("@/pages/RAG/CorpusPage")],
  },
  {
    prefix: ROUTES.PARTIES,
    loaders: [workspaceLayout, () => import("@/pages/Party/PartiesRails").then((m) => m), () => import("@/pages/Party/PartiesPage")],
  },
  {
    prefix: ROUTES.CONVERSATIONS,
    loaders: [workspaceLayout, () => import("@/pages/Party/PartiesRails").then((m) => m), () => import("@/pages/Conversation/ConsultationPage")],
  },
  {
    prefix: ROUTES.CONTRACTS,
    loaders: [workspaceLayout, () => import("@/pages/Contracts/ContractsRails").then((m) => m), () => import("@/pages/Contracts/AgreementsPage")],
  },
  {
    prefix: ROUTES.HRM,
    loaders: [workspaceLayout, () => import("@/pages/Hrm/CatalogPage")],
  },
  {
    prefix: "/governance",
    loaders: [workspaceLayout, () => import("@/pages/Governance/DataGovernanceRails").then((m) => m), () => import("@/pages/Governance/data-governance/CatalogPage")],
  },
  {
    prefix: ROUTES.GOVERNANCE_DRAFT_TEMPLATES,
    loaders: [workspaceLayout, () => import("@/pages/Governance/GovernanceRails").then((m) => m), () => import("@/pages/Governance/PromptTemplatesPage")],
  },
  {
    prefix: "/iam",
    loaders: [workspaceLayout, () => import("@/pages/IAM/IamRails").then((m) => m), () => import("@/pages/IAM/roles/RolesPage")],
  },
  {
    prefix: "/settings",
    loaders: [() => import("@/pages/UserWorkspace/SettingsPage")],
  },
];
